import React, { useRef, useState, useEffect } from "react";
import useMember from "../../../hooks/useMember";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
	checkPfNumber,
	memberLogin,
	verifyUserEmail,
} from "../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import Checkbox from "../CheckBox/CheckBox";
import "./Main.css";

const MainLogin = () => {
	const { setMem, mempersist, setMemPersist } = useMember();

	const navigate = useNavigate();
	const location = useLocation();
	const from = location.state?.from?.pathname || "/home";

	const [state, setState] = useState({
		pf_number_email: "",
		password: "",
		isFirstTimeLogin: false,
		isChecked: false,
		regInformation: true,
	});

	const userRef = useRef();

	useEffect(() => {
		userRef.current.focus();
	}, []);

	const handleAgreement = (e) => {
		const name = e.target.name;
		const value = e.target.checked;
		setState({
			...state,
			[name]: value,
			isChecked: value,
			regInformation: !state.regInformation,
		});
	};

	const handleChange = (e) => {
		e.preventDefault();
		const value = e.target.value;
		setState({
			...state,
			[e.target.name]: value,
		});
	};

	const handlePFNumber = async () => {
		let pfNumber = state.pf_number_email
			? state.pf_number_email.toLocaleUpperCase().trim()
			: "";
		try {
			if (!pfNumber) {
				toast.error("Please enter PF Number/Email Address", {
					duration: 5000,
					className: "toast-message",
				});
				userRef.current.focus();
				return false;
			} else {
				let sendData = [];
				checkPfNumber(pfNumber)
					.then((hasPswd) => {
						if (hasPswd.status === "not_found") {
							toast.error(hasPswd.message, {
								duration: 5000,
								className: "toast-message",
							});
							setState({
								...state,
								isFirstTimeLogin: state.isFirstTimeLogin,
							});
							userRef.current.focus();
							return false;
						}
						if (hasPswd.status === "blocked") {
							toast.error(hasPswd.message, {
								duration: 5000,
								className: "toast-message",
							});
							setState({
								...state,
								// pf_number_email: "",
								isFirstTimeLogin: state.isFirstTimeLogin,
							});
							userRef.current.focus();
							return false;
						}
						if (hasPswd.status === false) {
							setState({
								...state,
								isFirstTimeLogin: state.isFirstTimeLogin,
							});
							let useData = hasPswd.data;
							function extractData() {
								sendData = Object.keys(useData)
									.map(function (key) {
										return useData[key];
									})
									.join("&");
							}
							extractData();
							window.location.replace(
								`/set_member_password?user=${sendData}`
							);
						} else {
							setState({
								...state,
								isFirstTimeLogin: !state.isFirstTimeLogin,
							});
							return true;
						}
					})
					.catch((error) => {
						console.log(error);
					});
			}
		} catch (err) {
			if (err.response?.status === 400) {
				toast.error(err.response?.data, {
					duration: 5000,
					className: "toast-message",
				});
			} else if (err.response?.status === 401) {
				toast.error(err.response?.data, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.error("Login failed", {
					duration: 5000,
					className: "toast-message",
				});
			}
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!state.pf_number_email && !state.password) return false;

		const data = {
			pf_number_email: state.pf_number_email.trim(),
			password: state.password.trim(),
		};
		try {
			memberLogin(data).then((response) => {
				if (response.status === true) {
					const pfNumber = response?.pfNumber;
					const email = response?.email;
					const user = response?.user;
					const user_role = response?.user_role;
					const accessToken = response?.accessToken;

					setMem({ user, email, pfNumber, accessToken, user_role });
					setState({
						...state,
						pf_number_email: "",
						password: "",
					});
					navigate(from, { replace: true });
				}
				if (
					response.status === false &&
					response.login_attempts === 3
				) {
					toast.error(response.message, {
						duration: 5000,
						className: "toast-message",
					});
					setState({
						...state,
						pf_number_email: "",
						password: "",
					});
					return false;
				}
				if (response.status === false) {
					toast.error(response.message, {
						duration: 5000,
						className: "toast-message",
					});
					setState({
						...state,
						password: "",
					});
					return false;
				}
			});
		} catch (err) {
			if (err.response?.status === 400) {
				toast.error(err.response.data, {
					duration: 5000,
					className: "toast-message",
				});
				return false;
			} else if (err.response?.status === 401) {
				toast.error(err.response.data, {
					duration: 5000,
					className: "toast-message",
				});
			} else {
				toast.error("Login Failed", {
					duration: 5000,
					className: "toast-message",
				});
			}
		}
	};
	const toggleMemPersist = () => {
		setMemPersist((prev) => !prev);
	};

	useEffect(() => {
		localStorage.setItem("mempersist", mempersist);
	}, [mempersist]);

	const handleForgotPswd = () => {
		if (!state.pf_number_email) {
			toast.error("Enter your PF Number/Email Address", {
				duration: 5000,
				className: "toast-message",
			});
			userRef.current.focus();
			return false;
		}
		verifyUserEmail(state.pf_number_email).then(() => {
			navigate("/verify_secret_code");
		});
	};

	const openPopup = () => {
		setState({
			...state,
			regInformation: true,
			isChecked: false,
		});
		let popup = document.getElementById("popup");
		popup.classList.add("open-popup");
	};

	const closePopup = () => {
		setState({
			...state,
			regInformation: true,
			isChecked: false,
		});

		let popup = document.getElementById("popup");
		popup.classList.remove("open-popup");
	};

	const handleRegistration = () => {
		navigate("/registration");
	};

	const mainForm = (
		<>
			<form onSubmit={handleSubmit}>
				<div className="login-box">
					<h3>Membership Login</h3>
					<h4>Log in with your PF Number/Email and Password</h4>
				</div>
				{!state.isFirstTimeLogin ? (
					<div className="form-group row">
						<div className="col-sm-12">
							<input
								ref={userRef}
								id="pf_number_email"
								type="text"
								autoComplete="off"
								name="pf_number_email"
								style={{
									height: "40px",
									fontSize: "18px",
								}}
								placeholder="PF Number/Email Address"
								onChange={handleChange}
								value={state.pf_number_email}
								required
								className="box"
							/>
						</div>
					</div>
				) : null}
				{state.isFirstTimeLogin ? (
					<>
						<div className="form-group row">
							<div className="col-sm-12">
								<input
									type="password"
									name="password"
									placeholder="Password"
									autoComplete="off"
									required
									style={{
										height: "40px",
										fontSize: "18px",
									}}
									onChange={handleChange}
									value={state.password}
									maxLength="50"
									className="box"
								/>
							</div>
						</div>
						<input
							type="submit"
							value="Login"
							className="main-btn btn-success"
						/>
						<div className="forgot-pswd">
							<Link onClick={handleForgotPswd}>
								Forgot password?
							</Link>
						</div>
						<div className="persistenceCheck">
							<input
								type="checkbox"
								id="memPersist"
								onChange={toggleMemPersist}
								checked={mempersist}
							/>
							<label htmlFor="memPersist">
								{" "}
								Remember me on this device
							</label>
						</div>
					</>
				) : (
					<>
						<button
							onClick={handlePFNumber}
							type="button"
							value="Login"
							className="main-btn btn-success"
						>
							Next
						</button>
					</>
				)}
			</form>
		</>
	);

	const joinForm = (
		<>
			<div className="join-box">
				<h3>Join ProForum</h3>
				<h4>
					Join NDC Professionals Forum by completing the Online
					Application Form
				</h4>
				<Link onClick={openPopup} className="main-btn btn-success ">
					Join
				</Link>
			</div>

			<div className="popup" id="popup">
				<div className="popup-image">
					<img src="/images/logos/proforum_main.jpg" alt="proforum" />
				</div>
				<div className="info">
					<h2>Registration Information</h2>
					<h3>To apply for NDC Professionals Forum membership</h3>
					<h3>
						you shall be required to pay a subscription fee of
						GHS1,000.00{" "}
					</h3>
				</div>
				<hr />
				<div className="checkbox-wrapper">
					<Checkbox
						label="I accept the registration information"
						checked={state.isChecked}
						handleAgreement={handleAgreement}
					/>
					<div className="row">
						<div className="col-sm-6">
							<button
								type="button"
								className="btn btn-success btn-block"
								onClick={handleRegistration}
								disabled={state.regInformation}
							>
								Next
							</button>
						</div>
						<div className="col-sm-6">
							<button
								onClick={closePopup}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
				</div>
			</div>
		</>
	);

	const boxGroup = (
		<>
			<div className="box">
				<a href="https://ndcprofessionals.com/" target="blank">
					<div className="icon">
						<img src="/images/logos/proforum.jpg" alt="Proforum" />
					</div>
					<h3 className="title">Visit Us</h3>
				</a>
			</div>
			<div className="box">
				<a href="/contact">
					<div className="icon">
						<img src="/images/logos/proforum.jpg" alt="Proforum" />
					</div>
					<h3 className="title">Contact Us</h3>
				</a>
			</div>
			<div className="box">
				<a href="/main_2m2_payments">
					<div className="icon">
						<img src="/images/logos/proforum.jpg" alt="Proforum" />
					</div>
					<h3 className="title">2M2 Special Payment</h3>
				</a>
			</div>
			<div className="box">
				<a href="/main_regular_payments">
					<div className="icon">
						<img src="/images/logos/proforum.jpg" alt="Proforum" />
					</div>
					<h3 className="title">Regular Payment</h3>
				</a>
			</div>
			{/* <div className="box">
				<a href="/dues_payments">
					<div className="icon">
						<img src="/images/logos/proforum.jpg" alt="Proforum" />
					</div>
					<h3 className="title">Dues Payment</h3>
				</a>
			</div> */}
			{/* <a href="/portal_guide">
                <div className="box">
                    <div className="icon">
                        <img src="/images/logos/proforum.jpg" alt="Proforum" />
                    </div>
                    <h3 className="title">Portal Guide</h3>
                </div>
            </a> */}
		</>
	);

	return (
		<>
			<section className="content-header">
				<Toaster toastOptions={{ position: "top-center" }} />
				<h1>
					<i className="fa-solid fa-children"></i> NDC Professionals
					Forum
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>
												<strong>
													MMS LANDING PAGE
												</strong>
											</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								<div className="index-container">
									<div className="left">
										{mainForm}
										{joinForm}
									</div>
									<div className="right">{boxGroup}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MainLogin;
